import { makeStyles } from "@mui/styles";
import { Button } from "components/Button/Button";
import { CancelButton } from "components/Form/components/CancelButton/CancelButton";
import { centeredPopoverRootStyle, Popover } from "components/Popover/Popover";
import styles from "../SchemaFormObjectKeyPopover.module.scss";

interface ChangeKeyConfirmationPopoverProps {
    isOpen: boolean;
    onClose: () => void;
    onSubmit: () => void;
    label: string;
    currentKey: string;
}

export const ChangeKeyConfirmationPopover = ({
    isOpen,
    onClose,
    onSubmit,
    label,
    currentKey,
}: ChangeKeyConfirmationPopoverProps) => {
    const useStyles = makeStyles(() => ({
        rootStyle: centeredPopoverRootStyle,
    }));
    const classes = useStyles();

    return (
        <Popover
            anchorReference="none"
            contentClassName={styles.SchemaFormObjectKeyPopover}
            rootClassName={styles.SchemaFormObjectKeyPopoverOverlay}
            closeOnInsideClick={false}
            isOpen={isOpen}
            classes={{ root: classes.rootStyle }}
        >
            <div className="">{`Changing key "${currentKey}" of ${label} will result in data loss.`}</div>
            <div className={styles.addButtonWrapper}>
                <CancelButton className={styles.addButton} onClick={onClose} />
                <Button variation="primary" className={styles.addButton} label="Ok" onClick={onSubmit} />
            </div>
        </Popover>
    );
};
